import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { LegalSettingsTabs, TermsAndPoliciesForm } from '../../../components';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { useConfig } from '../../../contexts/config';
import { useCurrentProject } from '../../../contexts/settings';
import { useProductAgreement } from '../../../hooks';
import { RouteParams } from '../../../routes/types';

const TermsAndPolicies = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { merchantId } = useConfig();
  const { fetchingAgreement } = useProductAgreement(merchantId);
  const { currentProjectFetching, error } = useCurrentProject(projectId);

  if (currentProjectFetching || fetchingAgreement) {
    return (
      <LegalSettingsTabs>
        <Preloader />
      </LegalSettingsTabs>
    );
  }

  if (error) {
    return <ToDashboardError error={error} pageName="terms-and-policies_open" />;
  }

  return (
    <LegalSettingsTabs>
      <TermsAndPoliciesForm projectId={projectId} />
    </LegalSettingsTabs>
  );
};

export default withRouter(TermsAndPolicies);
